import type React from 'react';
import styled from 'styled-components';
import { Typography } from '@/components';
import { TextStyles } from '@/constants';

export const OrderLineItemImage = styled.img({
  width: 56,
  height: 56,
  objectFit: 'contain',
  objectPosition: 'center',
});

export const OrderLineItemTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  wordBreak: 'break-all',
}));

const Anchor = styled.a(({ theme }) => ({
  textDecoration: 'underline',

  ':hover,:hover > *': {
    color: theme.colors.blue,
  },
}));

export const LinkWrapper = ({ href, children }: { href?: string; children: React.ReactNode }) => {
  if (!href) return <>{children}</>;

  return (
    <Anchor href={href} target='_blank' rel='noopener noreferrer'>
      {children}
    </Anchor>
  );
};

const Text = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
}));

export const OrderLineItemQuantity = ({ children }: { children: React.ReactNode }) => {
  return children ? <Text>{children}</Text> : null;
};

export const OrderLineItemTitleWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  a: {
    color: theme.colors.mediumEmphasisBlack,
  },
}));

export const OrderLineItemCost = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  textAlign: 'right',
  wordBreak: 'break-all',
  maxWidth: 120,
}));

export const OrderLineItemWrapper = styled.div<{ hasImage?: boolean }>(({ theme, hasImage }) => ({
  display: 'grid',
  gridTemplateColumns: hasImage ? 'minmax(56px, 56px) auto' : 'auto',
  alignItems: 'start',
  columnGap: theme.spacing[8],
}));
